// Extensiones de adjuntos permitidas para subir en documentos relacionados 
const EXTENSIONES_ADJUNTOS = [
  'XLSX',
  'PPTX',
  'DOC',
  'XLS',
  'PPT',
  'PDF',
  'JPG',
  'JPEG',
  'PNG',
  'ZIP',
  'RAR',
  '7Z',
  'GZ',
  'DOCX',
  'TXT',
  'BMP',
  'XML',
  'XSIG',
]

export {
  EXTENSIONES_ADJUNTOS
}
